"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopActions = void 0;
var react_1 = __importStar(require("react"));
var ShareIcon_1 = __importDefault(require("../../../../icons/ShareIcon"));
var ProductFavorite_1 = require("../../../common/ProductFavorite");
var styled_components_1 = __importDefault(require("styled-components"));
var product_1 = require("../../ducks/product");
var react_redux_1 = require("react-redux");
var GenericMessage_1 = __importDefault(require("../../../common/GenericMessage"));
var DesktopActions = function () {
    var _a = (0, react_redux_1.useSelector)(product_1.productSelector), _b = _a.permalink, permalink = _b === void 0 ? '' : _b, product = __rest(_a, ["permalink"]);
    var _c = (0, react_1.useState)(undefined), status = _c[0], setStatus = _c[1];
    var _d = (0, react_1.useState)(false), message = _d[0], setMessage = _d[1];
    var _e = (0, react_1.useState)(''), messageText = _e[0], setMessageText = _e[1];
    (0, react_1.useEffect)(function () {
        message && setTimeout(function () { return setMessage(false); }, 3000);
    }, [message]);
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(ProductFavorite_1.ProductFavorite, { product: product, alwaysVisible: true }),
        react_1.default.createElement(IconButton, { onClick: function () {
                ;
                (navigator.clipboard
                    ? navigator.clipboard.writeText(permalink)
                    : Promise.reject())
                    .then(function () {
                    console.log('write permalink');
                    setMessage(true);
                    setMessageText('Ссылка скопирована в буфер обмена');
                    setStatus('success');
                })
                    .catch(function () {
                    setMessage(true);
                    setMessageText('Не удалось скопировать ссылку');
                    setStatus('error');
                });
            } },
            react_1.default.createElement(ShareIcon_1.default, null)),
        react_1.default.createElement(GenericMessage_1.default, { status: status, open: message, text: messageText })));
};
exports.DesktopActions = DesktopActions;
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 10000;\n\n  @media (max-width: 940px) {\n    display: none;\n  }\n"], ["\n  display: flex;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 10000;\n\n  @media (max-width: 940px) {\n    display: none;\n  }\n"])));
var IconButton = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 32px;\n  width: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 50%;\n  background-color: transparent;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n"], ["\n  height: 32px;\n  width: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 50%;\n  background-color: transparent;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n"])));
var templateObject_1, templateObject_2;
